import { v4 as uuidv4 } from 'uuid';
/**
 * Copies the lines of another deal as new lines (local ids): prices,
 * quantities, dates, options, packages and fields are kept as is. Item
 * alternatives follow their copied target; option and package alternatives
 * point at products and need no change.
 *
 * @function copyDealItems
 * @since 1.0.0
 */
export function copyDealItems(items) {
    const ids = new Map(items.map((item) => [item.id, uuidv4()]));
    return items.map((item) => {
        var _a, _b, _c;
        return (Object.assign(Object.assign({}, item), { id: ids.get(item.id), alternativeTo: item.alternativeTo
                ? ((_a = ids.get(item.alternativeTo)) !== null && _a !== void 0 ? _a : null)
                : null, options: (_b = item.options) === null || _b === void 0 ? void 0 : _b.map((option) => (Object.assign(Object.assign({}, option), { id: uuidv4() }))), packages: (_c = item.packages) === null || _c === void 0 ? void 0 : _c.map((pack) => (Object.assign(Object.assign({}, pack), { id: uuidv4() }))) }));
    });
}
/**
 * Lines whose product, variant, option or package is inactive or deleted.
 *
 * @function getInactiveDealItems
 * @since 1.0.0
 */
export function getInactiveDealItems(items) {
    return items.filter((item) => {
        var _a, _b;
        const isItemActive = item.item.active && !item.item.deletedAt;
        const isVariantActive = !item.variant || (item.variant.active && !item.variant.deletedAt);
        const isOptionAllActive = (_a = item.options) === null || _a === void 0 ? void 0 : _a.every((option) => { var _a, _b; return ((_a = option.item) === null || _a === void 0 ? void 0 : _a.active) && !((_b = option.item) === null || _b === void 0 ? void 0 : _b.deletedAt); });
        const isPackageAllActive = (_b = item.packages) === null || _b === void 0 ? void 0 : _b.every((pack) => { var _a, _b; return ((_a = pack.package) === null || _a === void 0 ? void 0 : _a.active) && !((_b = pack.package) === null || _b === void 0 ? void 0 : _b.deletedAt); });
        return (!isItemActive ||
            !isVariantActive ||
            !isOptionAllActive ||
            !isPackageAllActive);
    });
}
